module.exports = __webpack_public_path__ + "static/img/icon_14.89dc113.png";


//////////////////
// WEBPACK FOOTER
// ./static/user/icon_14.png
// module id = Z/zX
// module chunks = 1